// extracted by mini-css-extract-plugin
export const sectionTitleWrapper = "SectionTitle-module--section-title-wrapper--3yCpq";
export const sectionTitleCenter = "SectionTitle-module--section-title--center--1OdlC";
export const sectionTitleTagCenter = "SectionTitle-module--section-title-tag--center--iBVwH";
export const sectionTitleTag = "SectionTitle-module--section-title-tag--28PzU";
export const sectionTitleWhite = "SectionTitle-module--section-title--white--1yDPG";
export const sectionTitle = "SectionTitle-module--section-title--2vIvo";
export const sectionTitleLeft = "SectionTitle-module--section-title--left--2LHjV";
export const sectionTitleTagLeft = "SectionTitle-module--section-title-tag--left--3VjRG";